// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"a21b821e","608":"4b9baf26","787":"207040db","877":"5e374c11","913":"b1d59b9f"}[chunkId] + ".chunk.js";
};